import script from "./LogPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LogPanel.vue?vue&type=script&setup=true&lang=js"

import "./LogPanel.vue?vue&type=style&index=0&id=23abb582&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23abb582"]])

export default __exports__